import React, { useEffect } from 'react'
import { Outlet, Navigate, useNavigate } from 'react-router'
import AppHeader from './AppHeader'
import Backdrop from './Backdrop'
import AppSidebar from './AppSidebar'
import { isTokenExpired } from '../functions/jwt'
import { useAuth } from '../context/AuthContext'
import { SidebarProvider, useSidebar } from '../context/SidebarContext'
import FloatingWhatsapp from '../components/layout/FloatingWhatsapp'

const LayoutContent: React.FC = () => {
    const { token, signOut } = useAuth()
    const navigate = useNavigate()
    const { isExpanded, isHovered, isMobileOpen } = useSidebar()

    //* Verifica expiração do Token somente ao recarregar a tela (Token expira em 24 horas)
    useEffect(() => {
        const token = localStorage.getItem('@crm-auth')
        if (!token || isTokenExpired(token)) {
            signOut()
            navigate('/login')
        }
    }, [])

    if (!token) {
        return <Navigate to='/login' replace />
    }

    return (
        <div className='min-h-screen xl:flex'>
            <div>
                <AppSidebar />
                <Backdrop />
            </div>
            <div
                className={`flex-1 transition-all duration-300 ease-in-out ${
                    isExpanded || isHovered ? 'lg:ml-[240px]' : 'lg:ml-[90px]'
                } ${isMobileOpen ? 'ml-0' : ''}`}
            >
                <AppHeader />
                <div className='py-4 w-full mx-auto max-w-[85vw]'>
                    <Outlet />
                </div>
            </div>
        </div>
    )
}

const AppLayout: React.FC = () => {
    return (
        <SidebarProvider>
            <LayoutContent />
            <FloatingWhatsapp />
        </SidebarProvider>
    )
}

export default AppLayout
